import {DataTable} from 'pepsico-ds'
import {useNavigate} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'

const columns = [
  {
    columnKey: 'blank', // Need this column because the component cannot handle rendering a customer cell in the fist column
    header: '',
  },
  {
    columnKey: 'title',
    header: 'Title',
    cellData: ctx => {
      const title = ctx?.row?.original?.title
      return <button className="text-primary-400">{title}</button>
    },
  },
  {
    columnKey: 'numCustomers',
    header: '# Customers',
  },
  {
    columnKey: 'percentCompleted',
    header: '% Completed',
    cellData: ctx => {
      return <p className="w-full text-right font-bold">{ctx.row.original.percentCompleted}%</p>
    },
  },
  {columnKey: 'totalPointsAwarded', header: 'Total Points Awarded'},
  {columnKey: 'lastUpdated', header: 'Last Updated'},
  {columnKey: 'updatedBy', header: 'Updated By'},
]

const getSecureRandomInt = max => {
  const array = new Uint32Array(1)
  crypto.getRandomValues(array)
  return array[0] % max
}

const mockData = [
  {
    title: 'Welcome Points',
    numCustomers: 150,
    percentCompleted: 75,
    totalPointsAwarded: 250,
    lastUpdated: '2024-01-01',
    updatedBy: 'John Smith',
  },
  {
    title: 'Login Bonus',
    numCustomers: 200,
    percentCompleted: 75,
    totalPointsAwarded: 250,
    lastUpdated: '2024-02-01',
    updatedBy: 'John Smith',
  },
  {
    title: 'Order Delivery Points',
    numCustomers: 100,
    percentCompleted: 75,
    totalPointsAwarded: 250,
    lastUpdated: '2024-02-01',
    updatedBy: 'John Smith',
  },
  {
    blank: '',
    title: 'Special Activity',
    numCustomers: 75,
    percentCompleted: 75,
    totalPointsAwarded: 250,
    lastUpdated: '2024-02-01',
    updatedBy: 'John Smith',
  },
  ...Array.from({length: 50}, (_, i) => {
    const numCustomers = getSecureRandomInt(500)
    const percentCompleted = getSecureRandomInt(101)
    const totalPointsAwarded = getSecureRandomInt(1000)
    const month = getSecureRandomInt(12)
    const day = getSecureRandomInt(28) + 1
    const updatedBy = ['John Smith', 'Jane Doe', 'Bob Wilson', 'Alice Brown'][getSecureRandomInt(4)]

    return {
      title: `Activity ${i + 5}`,
      numCustomers,
      percentCompleted,
      totalPointsAwarded,
      lastUpdated: new Date(2024, month, day).toISOString().split('T')[0],
      updatedBy,
    }
  }),
]

const ActivitiesListTable = () => {
  const navigate = useNavigate()

  // Generate filter options based on titles in mockData
  const titleOptions = Array.from(new Set(mockData.map(item => item.title))).map(title => ({
    id: title.toLowerCase().replace(/\s+/g, '-'),
    label: title,
  }))

  const filters = [
    {
      disabled: false,
      label: 'Filter by Title',
      listLabel: 'Title',
      onChange: () => {},
      options: titleOptions,
    },
  ]

  return (
    <div className="activities-list-table">
      <DataTable
        columns={columns}
        data={mockData}
        isDark={true}
        filters={filters}
        tableDescription=""
        tableHeader=""
        size="small"
        selection={'single'}
        toolbarActions={[
          {
            text: 'Add Activities',
            variant: 'primary',
            onClick: () => navigate(ROUTES.ACTIVITIES_CONFIGURE.replace(':type?', '')),
          },
        ]}
      />
    </div>
  )
}

export default ActivitiesListTable
